import { Injectable } from '@angular/core';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';

interface CreateEventPayload {
  url: string;
  document_id: string;
}

@Injectable({
  providedIn: 'root',
})
export class CkEditorService {
  constructor(private apiService: APICoreService) {}

  createEventLog(payload: CreateEventPayload) {
    return this.apiService.postRequest('event-log', payload);
  }
}
